import { render, staticRenderFns } from "./VisitFrequencyReport.vue?vue&type=template&id=02289887&scoped=true"
import script from "./VisitFrequencyReport.vue?vue&type=script&lang=js"
export * from "./VisitFrequencyReport.vue?vue&type=script&lang=js"
import style0 from "./VisitFrequencyReport.vue?vue&type=style&index=0&id=02289887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02289887",
  null
  
)

export default component.exports